import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "crm:text-zinc-500 crm:px-2" }
const _hoisted_2 = {
  key: 0,
  class: "crm:mt-4"
}
const _hoisted_3 = { class: "crm:text-zinc-500 crm:px-2" }
const _hoisted_4 = {
  key: 0,
  class: "crm:mt-4"
}
const _hoisted_5 = { class: "crm:text-zinc-500 crm:px-2" }
const _hoisted_6 = {
  key: 0,
  class: "crm:mt-4 crm:px-4"
}
const _hoisted_7 = { class: "crm:mt-4" }
const _hoisted_8 = {
  key: 1,
  class: "crm:overflow-y-scroll crm:h-[100vh] crm:transition-all crm:h-full crm:fixed crm:top-0 crm:right-[40%] crm:z-[2000] crm:w-[40%] crm:bg-white crm:shadow-md crm:border-l-2 crm:border-black"
}

import DesignSystem from "./preview/DesignSystem.vue";
import {inject, provide, reactive, ref} from "vue";
import 'highlight.js/styles/monokai.css';
import {useDefaultStore, usePraticaStore} from "../store/crm.store";
import randomSurname from "./random-surname.json";
import randomName from "./random-name.json";
import codiciComuniJSON from "./codici_comuni.json";
import { generateFiscalCode } from "./fiscal_code_generator";
import ComponentsDoc from "./documentation/ComponentsDoc.vue";
import AppComponentsDocItem from "./documentation/AppComponentsDocItem.vue";


export default {
  __name: 'TheDevSidebar',
  setup(__props) {

const isShowDev = ref(false);
const isShowDevExpand = ref(false)
const isLocal = ref(["localhost", "locale"].indexOf(window.location.host.split(".")[0]) > -1)

window.addEventListener('mousemove', (event) => {
  isShowDev.value = event.clientX > 1850 || isShowDevExpand.value
});

const generatorsSection = reactive({
  isShow: false,
  numeroDiSoggetti: {value: 0},
  log: []
})

const documentationSection = reactive({
  isShow: false
})

const feactureSection = reactive({
  isShow: false
})

const {feacturesList} = useDefaultStore()
const $AxiosClient = inject('$AxiosClient');
const praticaStore = usePraticaStore();

const randTestYear = (start, end) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  ).getFullYear();
};

function generate_fiscal_code() {
  let cognome =
    randomSurname.data[Math.floor(Math.random() * randomSurname.data.length)];

  let nome =
    randomName.data[Math.floor(Math.random() * randomName.data.length)];
  let anno = randTestYear(new Date(1991, 0, 1), new Date()).toString();
  let mese = Math.floor(Math.random() * 12).toString();
  mese = mese === "0" ? "01" : mese.length > 1 ? mese : "0" + mese;
  let giorno = Math.floor(Math.random() * 28).toString();
  let luogo = Object.keys(codiciComuniJSON);
  luogo =
    luogo[Math.floor(Math.random() * Object.keys(codiciComuniJSON).length)];

  return {
    anagrafica: {
      cognome: cognome,
      nome: nome,
      anno: anno,
      mese: mese,
      giorno: giorno,
      sesso: "F",
      luogo_nascita: luogo,
    },
    cf: generateFiscalCode(cognome, nome, anno, mese, giorno, "F", luogo),
  };
}

async function generaSoggetti() {
  for (let i = 0; i < parseInt(generatorsSection.numeroDiSoggetti.value); i++) {
    let soggettoGenerato = generate_fiscal_code();
    let obj = {
      "nome": soggettoGenerato.anagrafica.nome,
      "cognome": soggettoGenerato.anagrafica.cognome,
      "cod_fiscale": soggettoGenerato.cf,
      "sesso": soggettoGenerato.anagrafica.sesso,
      "email": 'gianluca.bombara@fallco.it',
      "pratica_id": praticaStore.praticaID
    };

    let createSoggetto = await $AxiosClient.post('Soggetto', 'aggiornaSoggetto', obj, {messages: false});
    generatorsSection.log.push(`Soggetto ${obj.nome} ${obj.cognome} -> ${obj.cod_fiscale} ${createSoggetto && createSoggetto.esito === 'ok' ? 'creato con successo' : 'errore nella creazione'}`)
  }
}

const docComponent = ref([])
const isShowComponentDoc = ref(false)

provide("updateIsShowComponentDoc", (status) => isShowComponentDoc.value = status)
provide("updateDocComponent", (component) => docComponent.value = component)

return (_ctx, _cache) => {
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createBlock(_Transition, {
    name: "smooth",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (isShowDev.value && isLocal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([[isShowDevExpand.value ? 'crm:w-[40%] crm:bg-white crm:shadow-md crm:border-l-2 crm:border-black' : 'crm:w-[10px] crm:bg-gradient-to-b crm:from-[#8E2DE2] crm:to-[#4A00E0]'], "crm:transition-all crm:h-full crm:fixed crm:top-0 crm:right-0 crm:z-[2200]"])
            }, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => { isShowDevExpand.value = !isShowDevExpand.value; isShowComponentDoc.value = false;}, ["prevent"])),
                class: _normalizeClass([[isShowDevExpand.value ? 'crm:bg-white crm:text-black crm:border-l-2 crm:border-black crm:right-[22px]' : 'crm:right-[30px] crm:bg-gradient-to-l crm:from-[#4A00E0] crm:to-[#8E2DE2] crm:text-white'], "crm:transition-all crm:top-[50%] crm:relative crm:flex crm:items-center crm:pl-2 crm:justify-start crm:font-bold crm:w-[50px] crm:h-[50px] crm:rounded-full crm:cursor-pointer"])
              }, " DEV ", 2 /* CLASS */),
              (isShowDevExpand.value)
                ? (_openBlock(), _createBlock(DesignSystem, { key: 0 }))
                : _createCommentVNode("v-if", true),
              (isShowDevExpand.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([{'crm:h-[80vh]': feactureSection.isShow}, "crm:px-4 crm:overflow-y-scroll crm:border-b crm:pb-4 markdown-container"])
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "crm:px-2 crm:font-bold crm:text-2xl crm:bg-clip-text crm:bg-gradient-to-r crm:from-[#8E2DE2] crm:to-[#4A00E0] crm:text-transparent" }, "Funzionalità", -1 /* CACHED */)),
                    _createElementVNode("p", _hoisted_1, [
                      _cache[6] || (_cache[6] = _createTextVNode(" Funzionalità attivabili via Url presenti: ", -1 /* CACHED */)),
                      _createElementVNode("span", {
                        class: "crm:inline-block crm:ml-6 crm:cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (feactureSection.isShow = !feactureSection.isShow), ["prevent"]))
                      }, _toDisplayString(feactureSection.isShow ? 'Chiudi': 'Apri'), 1 /* TEXT */)
                    ]),
                    (feactureSection.isShow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feacturesList).value, (feacture, feactureKey) => {
                              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(feactureKey), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              (isShowDevExpand.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass([{'crm:h-[80vh]': documentationSection.isShow}, "crm:px-4 crm:overflow-y-hidden crm:border-b crm:pb-4 markdown-container crm:mt-4"])
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "crm:font-bold crm:text-2xl crm:bg-clip-text crm:bg-gradient-to-r crm:from-[#8E2DE2] crm:to-[#4A00E0] crm:text-transparent crm:px-2" }, "Documentazione", -1 /* CACHED */)),
                    _createElementVNode("p", _hoisted_3, [
                      _cache[8] || (_cache[8] = _createTextVNode(" Documentazione tecnica interna ", -1 /* CACHED */)),
                      _createElementVNode("span", {
                        class: "crm:inline-block crm:ml-6 crm:cursor-pointer",
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (documentationSection.isShow = !documentationSection.isShow), ["prevent"]))
                      }, _toDisplayString(documentationSection.isShow ? 'Chiudi': 'Apri'), 1 /* TEXT */)
                    ]),
                    (documentationSection.isShow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createCommentVNode("          <Markdown :source=\"ReadmeDev\" />"),
                          _createVNode(ComponentsDoc)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              (isShowDevExpand.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass([{'crm:h-[80vh]': generatorsSection.isShow}, "crm:px-4 crm:overflow-y-scroll crm:border-b crm:pb-4 markdown-container crm:mt-4"])
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "crm:font-bold crm:text-2xl crm:bg-clip-text crm:bg-gradient-to-r crm:from-[#8E2DE2] crm:to-[#4A00E0] crm:text-transparent crm:px-2" }, "Generatori", -1 /* CACHED */)),
                    _createElementVNode("p", _hoisted_5, [
                      _cache[10] || (_cache[10] = _createTextVNode(" genera dati per facilitare i test ", -1 /* CACHED */)),
                      _createElementVNode("span", {
                        class: "crm:inline-block crm:ml-6 crm:cursor-pointer",
                        onClick: _cache[3] || (_cache[3] = _withModifiers($event => (generatorsSection.isShow = !generatorsSection.isShow), ["prevent"]))
                      }, _toDisplayString(generatorsSection.isShow ? 'Chiudi': 'Apri'), 1 /* TEXT */)
                    ]),
                    (generatorsSection.isShow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "crm:font-bold" }, "Genera soggetti", -1 /* CACHED */)),
                          _createVNode(_component_base_input_text, {
                            placeholder: "inserire un numero ex. 10",
                            name: "genera_soggetti",
                            "validate-to": generatorsSection.numeroDiSoggetti,
                            "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((generatorsSection.numeroDiSoggetti) = $event))
                          }, null, 8 /* PROPS */, ["validate-to"]),
                          _createVNode(_component_base_button, {
                            class: "crm:mt-2!",
                            "onClick:cta": _cache[5] || (_cache[5] = $event => (generaSoggetti()))
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Genera", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          _createElementVNode("ul", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(generatorsSection.log, (log) => {
                              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(log), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        (isShowDevExpand.value && isShowComponentDoc.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(AppComponentsDocItem, {
                component: docComponent.value.components,
                "comp-key": docComponent.value.title
              }, null, 8 /* PROPS */, ["component", "comp-key"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

}